
qx.Class.define("osparc.theme.colorProvider.ColorProvider", {
  type: "static",

  statics: {
    // nested-zmt-dark.json
    colors: {
      "color": {
        "scales": {
          "static": {
            "base": {
              "0": [
                255,
                255,
                255,
                1
              ],
              "1": [
                248,
                249,
                249,
                1
              ],
              "2": [
                246,
                247,
                248,
                1
              ],
              "3": [
                244,
                245,
                246,
                1
              ],
              "4": [
                242,
                244,
                245,
                1
              ],
              "5": [
                240,
                242,
                243,
                1
              ],
              "6": [
                238,
                240,
                242,
                1
              ],
              "7": [
                236,
                238,
                240,
                1
              ],
              "8": [
                234,
                237,
                239,
                1
              ],
              "9": [
                232,
                235,
                237,
                1
              ],
              "10": [
                230,
                233,
                236,
                1
              ],
              "15": [
                220,
                225,
                228,
                1
              ],
              "20": [
                210,
                216,
                220,
                1
              ],
              "25": [
                199,
                207,
                212,
                1
              ],
              "30": [
                189,
                197,
                203,
                1
              ],
              "35": [
                179,
                188,
                195,
                1
              ],
              "40": [
                168,
                178,
                185,
                1
              ],
              "45": [
                158,
                169,
                176,
                1
              ],
              "50": [
                148,
                159,
                166,
                1
              ],
              "55": [
                137,
                148,
                156,
                1
              ],
              "60": [
                127,
                138,
                145,
                1
              ],
              "65": [
                116,
                127,
                134,
                1
              ],
              "70": [
                106,
                116,
                123,
                1
              ],
              "75": [
                95,
                104,
                110,
                1
              ],
              "80": [
                83,
                92,
                98,
                1
              ],
              "85": [
                72,
                79,
                84,
                1
              ],
              "90": [
                59,
                66,
                70,
                1
              ],
              "95": [
                46,
                52,
                55,
                1
              ],
              "100": [
                32,
                36,
                38,
                1
              ],
              "101": [
                28,
                31,
                34,
                1
              ],
              "102": [
                24,
                27,
                29,
                1
              ],
              "103": [
                19,
                22,
                24,
                1
              ],
              "104": [
                13,
                16,
                17,
                1
              ],
              "105": [
                7,
                8,
                9,
                1
              ]
            },
            "warning": {
              "2": [
                255,
                245,
                238,
                1
              ],
              "4": [
                255,
                241,
                230,
                1
              ],
              "5": [
                255,
                239,
                226,
                1
              ],
              "6": [
                255,
                237,
                222,
                1
              ],
              "8": [
                255,
                233,
                215,
                1
              ],
              "10": [
                255,
                228,
                207,
                1
              ],
              "15": [
                255,
                217,
                186,
                1
              ],
              "20": [
                255,
                205,
                165,
                1
              ],
              "25": [
                254,
                193,
                142,
                1
              ],
              "30": [
                254,
                181,
                117,
                1
              ],
              "35": [
                253,
                168,
                89,
                1
              ],
              "40": [
                251,
                154,
                56,
                1
              ],
              "45": [
                243,
                143,
                32,
                1
              ],
              "50": [
                229,
                133,
                22,
                1
              ],
              "55": [
                215,
                124,
                16,
                1
              ],
              "60": [
                201,
                115,
                12,
                1
              ],
              "65": [
                185,
                106,
                9,
                1
              ],
              "70": [
                169,
                96,
                7,
                1
              ],
              "75": [
                153,
                86,
                5,
                1
              ],
              "80": [
                136,
                76,
                4,
                1
              ],
              "85": [
                118,
                65,
                3,
                1
              ],
              "90": [
                99,
                54,
                2,
                1
              ],
              "95": [
                79,
                42,
                1,
                1
              ],
              "100": [
                56,
                28,
                1,
                1
              ],
              "101": [
                50,
                24,
                1,
                1
              ],
              "102": [
                44,
                21,
                0,
                1
              ],
              "103": [
                36,
                16,
                0,
                1
              ],
              "104": [
                28,
                11,
                0,
                1
              ],
              "105": [
                17,
                5,
                0,
                1
              ]
            },
            "danger": {
              "2": [
                255,
                245,
                243,
                1
              ],
              "4": [
                255,
                240,
                238,
                1
              ],
              "5": [
                255,
                238,
                236,
                1
              ],
              "6": [
                255,
                236,
                233,
                1
              ],
              "8": [
                255,
                231,
                228,
                1
              ],
              "10": [
                255,
                227,
                223,
                1
              ],
              "15": [
                254,
                215,
                210,
                1
              ],
              "20": [
                254,
                203,
                197,
                1
              ],
              "25": [
                254,
                190,
                183,
                1
              ],
              "30": [
                254,
                177,
                168,
                1
              ],
              "35": [
                254,
                163,
                153,
                1
              ],
              "40": [
                253,
                148,
                138,
                1
              ],
              "45": [
                253,
                132,
                121,
                1
              ],
              "50": [
                252,
                114,
                104,
                1
              ],
              "55": [
                250,
                94,
                86,
                1
              ],
              "60": [
                248,
                70,
                66,
                1
              ],
              "65": [
                240,
                45,
                49,
                1
              ],
              "70": [
                221,
                36,
                42,
                1
              ],
              "75": [
                201,
                30,
                36,
                1
              ],
              "80": [
                179,
                24,
                30,
                1
              ],
              "85": [
                156,
                19,
                25,
                1
              ],
              "90": [
                132,
                15,
                19,
                1
              ],
              "95": [
                106,
                10,
                13,
                1
              ],
              "100": [
                76,
                5,
                7,
                1
              ],
              "101": [
                69,
                4,
                6,
                1
              ],
              "102": [
                60,
                3,
                4,
                1
              ],
              "103": [
                51,
                2,
                3,
                1
              ],
              "104": [
                40,
                1,
                2,
                1
              ],
              "105": [
                26,
                1,
                1,
                1
              ]
            },
            "zmt": {
              "2": [
                239,
                248,
                255,
                1
              ],
              "4": [
                232,
                245,
                255,
                1
              ],
              "5": [
                229,
                244,
                254,
                1
              ],
              "6": [
                225,
                242,
                254,
                1
              ],
              "8": [
                218,
                239,
                254,
                1
              ],
              "10": [
                211,
                236,
                254,
                1
              ],
              "15": [
                193,
                229,
                254,
                1
              ],
              "20": [
                173,
                221,
                254,
                1
              ],
              "25": [
                153,
                213,
                253,
                1
              ],
              "30": [
                132,
                204,
                252,
                1
              ],
              "35": [
                109,
                195,
                251,
                1
              ],
              "40": [
                85,
                186,
                248,
                1
              ],
              "45": [
                59,
                176,
                243,
                1
              ],
              "50": [
                45,
                166,
                232,
                1
              ],
              "55": [
                35,
                155,
                219,
                1
              ],
              "60": [
                27,
                144,
                205,
                1
              ],
              "65": [
                22,
                133,
                190,
                1
              ],
              "70": [
                17,
                121,
                173,
                1
              ],
              "75": [
                14,
                109,
                157,
                1
              ],
              "80": [
                11,
                96,
                139,
                1
              ],
              "85": [
                8,
                83,
                121,
                1
              ],
              "90": [
                6,
                69,
                102,
                1
              ],
              "95": [
                4,
                54,
                81,
                1
              ],
              "100": [
                2,
                38,
                58,
                1
              ],
              "101": [
                1,
                33,
                52,
                1
              ],
              "102": [
                1,
                28,
                45,
                1
              ],
              "103": [
                1,
                23,
                38,
                1
              ],
              "104": [
                1,
                17,
                29,
                1
              ],
              "105": [
                0,
                9,
                18,
                1
              ]
            },
            "speag": {
              "2": [
                255,
                248,
                211,
                1
              ],
              "4": [
                255,
                244,
                192,
                1
              ],
              "5": [
                255,
                243,
                182,
                1
              ],
              "6": [
                255,
                241,
                172,
                1
              ],
              "8": [
                255,
                237,
                151,
                1
              ],
              "10": [
                255,
                233,
                129,
                1
              ],
              "15": [
                255,
                223,
                50,
                1
              ],
              "20": [
                247,
                214,
                0,
                1
              ],
              "25": [
                236,
                205,
                0,
                1
              ],
              "30": [
                226,
                195,
                0,
                1
              ],
              "35": [
                215,
                186,
                0,
                1
              ],
              "40": [
                204,
                176,
                0,
                1
              ],
              "45": [
                192,
                166,
                0,
                1
              ],
              "50": [
                181,
                156,
                0,
                1
              ],
              "55": [
                169,
                146,
                0,
                1
              ],
              "60": [
                157,
                135,
                0,
                1
              ],
              "65": [
                145,
                125,
                0,
                1
              ],
              "70": [
                132,
                114,
                0,
                1
              ],
              "75": [
                119,
                102,
                0,
                1
              ],
              "80": [
                105,
                90,
                0,
                1
              ],
              "85": [
                91,
                78,
                0,
                1
              ],
              "90": [
                76,
                65,
                0,
                1
              ],
              "95": [
                60,
                51,
                0,
                1
              ],
              "100": [
                42,
                35,
                0,
                1
              ],
              "101": [
                37,
                31,
                0,
                1
              ],
              "102": [
                32,
                26,
                0,
                1
              ],
              "103": [
                26,
                21,
                0,
                1
              ],
              "104": [
                19,
                15,
                0,
                1
              ],
              "105": [
                11,
                8,
                0,
                1
              ]
            },
            "inversed": {
              "base": {
                "0": [
                  255,
                  255,
                  255,
                  1
                ],
                "1": [
                  248,
                  249,
                  249,
                  1
                ],
                "2": [
                  246,
                  247,
                  248,
                  1
                ],
                "3": [
                  244,
                  245,
                  246,
                  1
                ],
                "4": [
                  242,
                  244,
                  245,
                  1
                ],
                "5": [
                  240,
                  242,
                  243,
                  1
                ],
                "6": [
                  238,
                  240,
                  242,
                  1
                ],
                "7": [
                  236,
                  238,
                  240,
                  1
                ],
                "8": [
                  234,
                  237,
                  239,
                  1
                ],
                "9": [
                  232,
                  235,
                  237,
                  1
                ],
                "10": [
                  230,
                  233,
                  236,
                  1
                ],
                "15": [
                  220,
                  225,
                  228,
                  1
                ],
                "20": [
                  210,
                  216,
                  220,
                  1
                ],
                "25": [
                  199,
                  207,
                  212,
                  1
                ],
                "30": [
                  189,
                  197,
                  203,
                  1
                ],
                "35": [
                  179,
                  188,
                  195,
                  1
                ],
                "40": [
                  168,
                  178,
                  185,
                  1
                ],
                "45": [
                  158,
                  169,
                  176,
                  1
                ],
                "50": [
                  148,
                  159,
                  166,
                  1
                ],
                "55": [
                  137,
                  148,
                  156,
                  1
                ],
                "60": [
                  127,
                  138,
                  145,
                  1
                ],
                "65": [
                  116,
                  127,
                  134,
                  1
                ],
                "70": [
                  106,
                  116,
                  123,
                  1
                ],
                "75": [
                  95,
                  104,
                  110,
                  1
                ],
                "80": [
                  83,
                  92,
                  98,
                  1
                ],
                "85": [
                  72,
                  79,
                  84,
                  1
                ],
                "90": [
                  59,
                  66,
                  70,
                  1
                ],
                "95": [
                  46,
                  52,
                  55,
                  1
                ],
                "100": [
                  32,
                  36,
                  38,
                  1
                ],
                "101": [
                  28,
                  31,
                  34,
                  1
                ],
                "102": [
                  24,
                  27,
                  29,
                  1
                ],
                "103": [
                  19,
                  22,
                  24,
                  1
                ],
                "104": [
                  13,
                  16,
                  17,
                  1
                ],
                "105": [
                  7,
                  8,
                  9,
                  1
                ]
              },
              "warning": {
                "2": [
                  255,
                  245,
                  238,
                  1
                ],
                "4": [
                  255,
                  241,
                  230,
                  1
                ],
                "5": [
                  255,
                  239,
                  226,
                  1
                ],
                "6": [
                  255,
                  237,
                  222,
                  1
                ],
                "8": [
                  255,
                  233,
                  215,
                  1
                ],
                "10": [
                  255,
                  228,
                  207,
                  1
                ],
                "15": [
                  255,
                  217,
                  186,
                  1
                ],
                "20": [
                  255,
                  205,
                  165,
                  1
                ],
                "25": [
                  254,
                  193,
                  142,
                  1
                ],
                "30": [
                  254,
                  181,
                  117,
                  1
                ],
                "35": [
                  253,
                  168,
                  89,
                  1
                ],
                "40": [
                  251,
                  154,
                  56,
                  1
                ],
                "45": [
                  243,
                  143,
                  32,
                  1
                ],
                "50": [
                  229,
                  133,
                  22,
                  1
                ],
                "55": [
                  215,
                  124,
                  16,
                  1
                ],
                "60": [
                  201,
                  115,
                  12,
                  1
                ],
                "65": [
                  185,
                  106,
                  9,
                  1
                ],
                "70": [
                  169,
                  96,
                  7,
                  1
                ],
                "75": [
                  153,
                  86,
                  5,
                  1
                ],
                "80": [
                  136,
                  76,
                  4,
                  1
                ],
                "85": [
                  118,
                  65,
                  3,
                  1
                ],
                "90": [
                  99,
                  54,
                  2,
                  1
                ],
                "95": [
                  79,
                  42,
                  1,
                  1
                ],
                "100": [
                  56,
                  28,
                  1,
                  1
                ],
                "101": [
                  50,
                  24,
                  1,
                  1
                ],
                "102": [
                  44,
                  21,
                  0,
                  1
                ],
                "103": [
                  36,
                  16,
                  0,
                  1
                ],
                "104": [
                  28,
                  11,
                  0,
                  1
                ],
                "105": [
                  17,
                  5,
                  0,
                  1
                ]
              },
              "danger": {
                "2": [
                  255,
                  245,
                  243,
                  1
                ],
                "4": [
                  255,
                  240,
                  238,
                  1
                ],
                "5": [
                  255,
                  238,
                  236,
                  1
                ],
                "6": [
                  255,
                  236,
                  233,
                  1
                ],
                "8": [
                  255,
                  231,
                  228,
                  1
                ],
                "10": [
                  255,
                  227,
                  223,
                  1
                ],
                "15": [
                  254,
                  215,
                  210,
                  1
                ],
                "20": [
                  254,
                  203,
                  197,
                  1
                ],
                "25": [
                  254,
                  190,
                  183,
                  1
                ],
                "30": [
                  254,
                  177,
                  168,
                  1
                ],
                "35": [
                  254,
                  163,
                  153,
                  1
                ],
                "40": [
                  253,
                  148,
                  138,
                  1
                ],
                "45": [
                  253,
                  132,
                  121,
                  1
                ],
                "50": [
                  252,
                  114,
                  104,
                  1
                ],
                "55": [
                  250,
                  94,
                  86,
                  1
                ],
                "60": [
                  248,
                  70,
                  66,
                  1
                ],
                "65": [
                  240,
                  45,
                  49,
                  1
                ],
                "70": [
                  221,
                  36,
                  42,
                  1
                ],
                "75": [
                  201,
                  30,
                  36,
                  1
                ],
                "80": [
                  179,
                  24,
                  30,
                  1
                ],
                "85": [
                  156,
                  19,
                  25,
                  1
                ],
                "90": [
                  132,
                  15,
                  19,
                  1
                ],
                "95": [
                  106,
                  10,
                  13,
                  1
                ],
                "100": [
                  76,
                  5,
                  7,
                  1
                ],
                "101": [
                  69,
                  4,
                  6,
                  1
                ],
                "102": [
                  60,
                  3,
                  4,
                  1
                ],
                "103": [
                  51,
                  2,
                  3,
                  1
                ],
                "104": [
                  40,
                  1,
                  2,
                  1
                ],
                "105": [
                  26,
                  1,
                  1,
                  1
                ]
              },
              "zmt": {
                "2": [
                  239,
                  248,
                  255,
                  1
                ],
                "4": [
                  232,
                  245,
                  255,
                  1
                ],
                "5": [
                  229,
                  244,
                  254,
                  1
                ],
                "6": [
                  225,
                  242,
                  254,
                  1
                ],
                "8": [
                  218,
                  239,
                  254,
                  1
                ],
                "10": [
                  211,
                  236,
                  254,
                  1
                ],
                "15": [
                  193,
                  229,
                  254,
                  1
                ],
                "20": [
                  173,
                  221,
                  254,
                  1
                ],
                "25": [
                  153,
                  213,
                  253,
                  1
                ],
                "30": [
                  132,
                  204,
                  252,
                  1
                ],
                "35": [
                  109,
                  195,
                  251,
                  1
                ],
                "40": [
                  85,
                  186,
                  248,
                  1
                ],
                "45": [
                  59,
                  176,
                  243,
                  1
                ],
                "50": [
                  45,
                  166,
                  232,
                  1
                ],
                "55": [
                  35,
                  155,
                  219,
                  1
                ],
                "60": [
                  27,
                  144,
                  205,
                  1
                ],
                "65": [
                  22,
                  133,
                  190,
                  1
                ],
                "70": [
                  17,
                  121,
                  173,
                  1
                ],
                "75": [
                  14,
                  109,
                  157,
                  1
                ],
                "80": [
                  11,
                  96,
                  139,
                  1
                ],
                "85": [
                  8,
                  83,
                  121,
                  1
                ],
                "90": [
                  6,
                  69,
                  102,
                  1
                ],
                "95": [
                  4,
                  54,
                  81,
                  1
                ],
                "100": [
                  2,
                  38,
                  58,
                  1
                ],
                "101": [
                  1,
                  33,
                  52,
                  1
                ],
                "102": [
                  1,
                  28,
                  45,
                  1
                ],
                "103": [
                  1,
                  23,
                  38,
                  1
                ],
                "104": [
                  1,
                  17,
                  29,
                  1
                ],
                "105": [
                  0,
                  9,
                  18,
                  1
                ]
              },
              "speag": {
                "2": [
                  255,
                  248,
                  211,
                  1
                ],
                "4": [
                  255,
                  244,
                  192,
                  1
                ],
                "5": [
                  255,
                  243,
                  182,
                  1
                ],
                "6": [
                  255,
                  241,
                  172,
                  1
                ],
                "8": [
                  255,
                  237,
                  151,
                  1
                ],
                "10": [
                  255,
                  233,
                  129,
                  1
                ],
                "15": [
                  255,
                  223,
                  50,
                  1
                ],
                "20": [
                  247,
                  214,
                  0,
                  1
                ],
                "25": [
                  236,
                  205,
                  0,
                  1
                ],
                "30": [
                  226,
                  195,
                  0,
                  1
                ],
                "35": [
                  215,
                  186,
                  0,
                  1
                ],
                "40": [
                  204,
                  176,
                  0,
                  1
                ],
                "45": [
                  192,
                  166,
                  0,
                  1
                ],
                "50": [
                  181,
                  156,
                  0,
                  1
                ],
                "55": [
                  169,
                  146,
                  0,
                  1
                ],
                "60": [
                  157,
                  135,
                  0,
                  1
                ],
                "65": [
                  145,
                  125,
                  0,
                  1
                ],
                "70": [
                  132,
                  114,
                  0,
                  1
                ],
                "75": [
                  119,
                  102,
                  0,
                  1
                ],
                "80": [
                  105,
                  90,
                  0,
                  1
                ],
                "85": [
                  91,
                  78,
                  0,
                  1
                ],
                "90": [
                  76,
                  65,
                  0,
                  1
                ],
                "95": [
                  60,
                  51,
                  0,
                  1
                ],
                "100": [
                  42,
                  35,
                  0,
                  1
                ],
                "101": [
                  37,
                  31,
                  0,
                  1
                ],
                "102": [
                  32,
                  26,
                  0,
                  1
                ],
                "103": [
                  26,
                  21,
                  0,
                  1
                ],
                "104": [
                  19,
                  15,
                  0,
                  1
                ],
                "105": [
                  11,
                  8,
                  0,
                  1
                ]
              }
            }
          },
          "zmt": {
            "2": [
              1,
              32,
              50,
              1
            ],
            "4": [
              2,
              42,
              63,
              1
            ],
            "5": [
              3,
              45,
              68,
              1
            ],
            "6": [
              3,
              49,
              73,
              1
            ],
            "8": [
              4,
              56,
              83,
              1
            ],
            "10": [
              5,
              62,
              92,
              1
            ],
            "15": [
              7,
              77,
              113,
              1
            ],
            "20": [
              10,
              91,
              132,
              1
            ],
            "25": [
              13,
              105,
              151,
              1
            ],
            "30": [
              16,
              117,
              168,
              1
            ],
            "35": [
              20,
              129,
              184,
              1
            ],
            "40": [
              25,
              140,
              200,
              1
            ],
            "45": [
              32,
              151,
              214,
              1
            ],
            "50": [
              41,
              162,
              227,
              1
            ],
            "55": [
              53,
              172,
              239,
              1
            ],
            "60": [
              74,
              182,
              246,
              1
            ],
            "65": [
              97,
              191,
              250,
              1
            ],
            "70": [
              120,
              200,
              252,
              1
            ],
            "75": [
              141,
              208,
              253,
              1
            ],
            "80": [
              161,
              216,
              253,
              1
            ],
            "85": [
              179,
              223,
              254,
              1
            ],
            "90": [
              197,
              231,
              254,
              1
            ],
            "95": [
              214,
              238,
              254,
              1
            ],
            "100": [
              230,
              245,
              255,
              1
            ],
            "101": [
              234,
              246,
              255,
              1
            ],
            "102": [
              237,
              247,
              255,
              1
            ],
            "103": [
              240,
              249,
              255,
              1
            ],
            "104": [
              243,
              250,
              255,
              1
            ],
            "105": [
              246,
              251,
              255,
              1
            ]
          },
          "speag": {
            "2": [
              36,
              30,
              0,
              1
            ],
            "4": [
              46,
              38,
              0,
              1
            ],
            "5": [
              50,
              42,
              0,
              1
            ],
            "6": [
              54,
              45,
              0,
              1
            ],
            "8": [
              61,
              52,
              0,
              1
            ],
            "10": [
              68,
              58,
              0,
              1
            ],
            "15": [
              85,
              72,
              0,
              1
            ],
            "20": [
              100,
              86,
              0,
              1
            ],
            "25": [
              114,
              98,
              0,
              1
            ],
            "30": [
              128,
              110,
              0,
              1
            ],
            "35": [
              141,
              121,
              0,
              1
            ],
            "40": [
              153,
              132,
              0,
              1
            ],
            "45": [
              165,
              142,
              0,
              1
            ],
            "50": [
              176,
              152,
              0,
              1
            ],
            "55": [
              188,
              162,
              0,
              1
            ],
            "60": [
              199,
              172,
              0,
              1
            ],
            "65": [
              209,
              181,
              0,
              1
            ],
            "70": [
              220,
              190,
              0,
              1
            ],
            "75": [
              230,
              199,
              0,
              1
            ],
            "80": [
              240,
              208,
              0,
              1
            ],
            "85": [
              250,
              216,
              0,
              1
            ],
            "90": [
              255,
              226,
              75,
              1
            ],
            "95": [
              255,
              235,
              138,
              1
            ],
            "100": [
              255,
              243,
              186,
              1
            ],
            "101": [
              255,
              245,
              195,
              1
            ],
            "102": [
              255,
              246,
              204,
              1
            ],
            "103": [
              255,
              248,
              213,
              1
            ],
            "104": [
              255,
              249,
              221,
              1
            ],
            "105": [
              255,
              251,
              230,
              1
            ]
          },
          "base": {
            "0": [
              0,
              0,
              0,
              1
            ],
            "1": [
              22,
              25,
              27,
              1
            ],
            "2": [
              27,
              30,
              33,
              1
            ],
            "3": [
              31,
              35,
              38,
              1
            ],
            "4": [
              35,
              39,
              42,
              1
            ],
            "5": [
              38,
              43,
              46,
              1
            ],
            "6": [
              41,
              46,
              50,
              1
            ],
            "7": [
              45,
              50,
              53,
              1
            ],
            "8": [
              47,
              53,
              57,
              1
            ],
            "9": [
              50,
              56,
              60,
              1
            ],
            "10": [
              53,
              59,
              63,
              1
            ],
            "15": [
              67,
              74,
              79,
              1
            ],
            "20": [
              79,
              87,
              93,
              1
            ],
            "25": [
              91,
              100,
              106,
              1
            ],
            "30": [
              102,
              112,
              119,
              1
            ],
            "35": [
              113,
              123,
              130,
              1
            ],
            "40": [
              123,
              134,
              142,
              1
            ],
            "45": [
              134,
              145,
              152,
              1
            ],
            "50": [
              144,
              155,
              162,
              1
            ],
            "55": [
              154,
              165,
              172,
              1
            ],
            "60": [
              164,
              174,
              181,
              1
            ],
            "65": [
              174,
              183,
              190,
              1
            ],
            "70": [
              184,
              192,
              199,
              1
            ],
            "75": [
              193,
              201,
              207,
              1
            ],
            "80": [
              203,
              210,
              215,
              1
            ],
            "85": [
              213,
              218,
              222,
              1
            ],
            "90": [
              222,
              227,
              230,
              1
            ],
            "95": [
              231,
              235,
              237,
              1
            ],
            "100": [
              241,
              243,
              244,
              1
            ],
            "101": [
              243,
              244,
              245,
              1
            ],
            "102": [
              244,
              246,
              247,
              1
            ],
            "103": [
              246,
              247,
              248,
              1
            ],
            "104": [
              248,
              249,
              250,
              1
            ],
            "105": [
              250,
              251,
              251,
              1
            ],
            "translucent": {
              "0": {
                "0": [
                  0,
                  0,
                  0,
                  0
                ],
                "5": [
                  0,
                  0,
                  0,
                  0.05
                ],
                "10": [
                  0,
                  0,
                  0,
                  0.1
                ],
                "15": [
                  0,
                  0,
                  0,
                  0.15
                ],
                "20": [
                  0,
                  0,
                  0,
                  0.2
                ],
                "25": [
                  0,
                  0,
                  0,
                  0.25
                ],
                "30": [
                  0,
                  0,
                  0,
                  0.3
                ],
                "35": [
                  0,
                  0,
                  0,
                  0.35
                ],
                "40": [
                  0,
                  0,
                  0,
                  0.4
                ],
                "45": [
                  0,
                  0,
                  0,
                  0.45
                ],
                "50": [
                  0,
                  0,
                  0,
                  0.5
                ],
                "55": [
                  0,
                  0,
                  0,
                  0.55
                ],
                "60": [
                  0,
                  0,
                  0,
                  0.6
                ],
                "65": [
                  0,
                  0,
                  0,
                  0.65
                ],
                "70": [
                  0,
                  0,
                  0,
                  0.7
                ],
                "75": [
                  0,
                  0,
                  0,
                  0.75
                ],
                "80": [
                  0,
                  0,
                  0,
                  0.8
                ],
                "85": [
                  0,
                  0,
                  0,
                  0.85
                ],
                "90": [
                  0,
                  0,
                  0,
                  0.9
                ],
                "95": [
                  0,
                  0,
                  0,
                  0.95
                ],
                "100": [
                  0,
                  0,
                  0,
                  1
                ]
              },
              "50": {
                "0": [
                  144,
                  155,
                  162,
                  0
                ],
                "5": [
                  144,
                  155,
                  162,
                  0.05
                ],
                "10": [
                  144,
                  155,
                  162,
                  0.1
                ],
                "15": [
                  144,
                  155,
                  162,
                  0.15
                ],
                "20": [
                  144,
                  155,
                  162,
                  0.2
                ],
                "25": [
                  144,
                  155,
                  162,
                  0.25
                ],
                "30": [
                  144,
                  155,
                  162,
                  0.3
                ],
                "35": [
                  144,
                  155,
                  162,
                  0.35
                ],
                "40": [
                  144,
                  155,
                  162,
                  0.4
                ],
                "45": [
                  144,
                  155,
                  162,
                  0.45
                ],
                "50": [
                  144,
                  155,
                  162,
                  0.5
                ],
                "55": [
                  144,
                  155,
                  162,
                  0.55
                ],
                "60": [
                  144,
                  155,
                  162,
                  0.6
                ],
                "65": [
                  144,
                  155,
                  162,
                  0.65
                ],
                "70": [
                  144,
                  155,
                  162,
                  0.7
                ],
                "75": [
                  144,
                  155,
                  162,
                  0.75
                ],
                "80": [
                  144,
                  155,
                  162,
                  0.8
                ],
                "85": [
                  144,
                  155,
                  162,
                  0.85
                ],
                "90": [
                  144,
                  155,
                  162,
                  0.9
                ],
                "95": [
                  144,
                  155,
                  162,
                  0.95
                ],
                "100": [
                  144,
                  155,
                  162,
                  1
                ]
              },
              "100": {
                "0": [
                  241,
                  243,
                  244,
                  0
                ],
                "5": [
                  241,
                  243,
                  244,
                  0.05
                ],
                "10": [
                  241,
                  243,
                  244,
                  0.1
                ],
                "15": [
                  241,
                  243,
                  244,
                  0.15
                ],
                "20": [
                  241,
                  243,
                  244,
                  0.2
                ],
                "25": [
                  241,
                  243,
                  244,
                  0.25
                ],
                "30": [
                  241,
                  243,
                  244,
                  0.3
                ],
                "35": [
                  241,
                  243,
                  244,
                  0.35
                ],
                "40": [
                  241,
                  243,
                  244,
                  0.4
                ],
                "45": [
                  241,
                  243,
                  244,
                  0.45
                ],
                "50": [
                  241,
                  243,
                  244,
                  0.5
                ],
                "55": [
                  241,
                  243,
                  244,
                  0.55
                ],
                "60": [
                  241,
                  243,
                  244,
                  0.6
                ],
                "65": [
                  241,
                  243,
                  244,
                  0.65
                ],
                "70": [
                  241,
                  243,
                  244,
                  0.7
                ],
                "75": [
                  241,
                  243,
                  244,
                  0.75
                ],
                "80": [
                  241,
                  243,
                  244,
                  0.8
                ],
                "85": [
                  241,
                  243,
                  244,
                  0.85
                ],
                "90": [
                  241,
                  243,
                  244,
                  0.9
                ],
                "95": [
                  241,
                  243,
                  244,
                  0.95
                ],
                "100": [
                  241,
                  243,
                  244,
                  1
                ]
              }
            }
          },
          "warning": {
            "2": [
              49,
              24,
              1,
              1
            ],
            "4": [
              61,
              31,
              1,
              1
            ],
            "5": [
              67,
              34,
              1,
              1
            ],
            "6": [
              71,
              37,
              1,
              1
            ],
            "8": [
              81,
              43,
              1,
              1
            ],
            "10": [
              89,
              48,
              2,
              1
            ],
            "15": [
              110,
              60,
              3,
              1
            ],
            "20": [
              129,
              72,
              4,
              1
            ],
            "25": [
              147,
              83,
              5,
              1
            ],
            "30": [
              164,
              93,
              6,
              1
            ],
            "35": [
              180,
              102,
              8,
              1
            ],
            "40": [
              195,
              112,
              10,
              1
            ],
            "45": [
              210,
              121,
              14,
              1
            ],
            "50": [
              224,
              130,
              19,
              1
            ],
            "55": [
              237,
              139,
              27,
              1
            ],
            "60": [
              249,
              148,
              39,
              1
            ],
            "65": [
              252,
              161,
              74,
              1
            ],
            "70": [
              253,
              174,
              103,
              1
            ],
            "75": [
              254,
              186,
              128,
              1
            ],
            "80": [
              254,
              198,
              150,
              1
            ],
            "85": [
              255,
              209,
              171,
              1
            ],
            "90": [
              255,
              220,
              191,
              1
            ],
            "95": [
              255,
              230,
              210,
              1
            ],
            "100": [
              255,
              240,
              228,
              1
            ],
            "101": [
              255,
              242,
              231,
              1
            ],
            "102": [
              255,
              244,
              235,
              1
            ],
            "103": [
              255,
              246,
              238,
              1
            ],
            "104": [
              255,
              248,
              242,
              1
            ],
            "105": [
              255,
              250,
              245,
              1
            ]
          },
          "danger": {
            "2": [
              67,
              4,
              5,
              1
            ],
            "4": [
              83,
              6,
              8,
              1
            ],
            "5": [
              90,
              7,
              10,
              1
            ],
            "6": [
              96,
              8,
              11,
              1
            ],
            "8": [
              108,
              10,
              14,
              1
            ],
            "10": [
              119,
              12,
              17,
              1
            ],
            "15": [
              146,
              17,
              23,
              1
            ],
            "20": [
              171,
              22,
              28,
              1
            ],
            "25": [
              193,
              28,
              34,
              1
            ],
            "30": [
              214,
              34,
              40,
              1
            ],
            "35": [
              234,
              42,
              47,
              1
            ],
            "40": [
              247,
              60,
              59,
              1
            ],
            "45": [
              250,
              86,
              79,
              1
            ],
            "50": [
              251,
              106,
              97,
              1
            ],
            "55": [
              253,
              125,
              114,
              1
            ],
            "60": [
              253,
              141,
              130,
              1
            ],
            "65": [
              254,
              156,
              146,
              1
            ],
            "70": [
              254,
              169,
              160,
              1
            ],
            "75": [
              254,
              182,
              174,
              1
            ],
            "80": [
              254,
              195,
              188,
              1
            ],
            "85": [
              254,
              206,
              201,
              1
            ],
            "90": [
              254,
              218,
              213,
              1
            ],
            "95": [
              255,
              229,
              225,
              1
            ],
            "100": [
              255,
              239,
              237,
              1
            ],
            "101": [
              255,
              241,
              239,
              1
            ],
            "102": [
              255,
              243,
              242,
              1
            ],
            "103": [
              255,
              245,
              244,
              1
            ],
            "104": [
              255,
              247,
              246,
              1
            ],
            "105": [
              255,
              249,
              248,
              1
            ],
            "translucent": {
              "50": {
                "0": [
                  251,
                  106,
                  97,
                  0
                ],
                "5": [
                  251,
                  106,
                  97,
                  0.05
                ],
                "10": [
                  251,
                  106,
                  97,
                  0.1
                ],
                "15": [
                  251,
                  106,
                  97,
                  0.15
                ],
                "20": [
                  251,
                  106,
                  97,
                  0.2
                ],
                "25": [
                  251,
                  106,
                  97,
                  0.25
                ],
                "30": [
                  251,
                  106,
                  97,
                  0.3
                ],
                "35": [
                  251,
                  106,
                  97,
                  0.35
                ],
                "40": [
                  251,
                  106,
                  97,
                  0.4
                ],
                "45": [
                  251,
                  106,
                  97,
                  0.45
                ],
                "50": [
                  251,
                  106,
                  97,
                  0.5
                ],
                "55": [
                  251,
                  106,
                  97,
                  0.55
                ],
                "60": [
                  251,
                  106,
                  97,
                  0.6
                ],
                "65": [
                  251,
                  106,
                  97,
                  0.65
                ],
                "70": [
                  251,
                  106,
                  97,
                  0.7
                ],
                "75": [
                  251,
                  106,
                  97,
                  0.75
                ],
                "80": [
                  251,
                  106,
                  97,
                  0.8
                ],
                "85": [
                  251,
                  106,
                  97,
                  0.85
                ],
                "90": [
                  251,
                  106,
                  97,
                  0.9
                ],
                "95": [
                  251,
                  106,
                  97,
                  0.95
                ],
                "100": [
                  251,
                  106,
                  97,
                  1
                ]
              },
              "100": {
                "0": [
                  255,
                  239,
                  237,
                  0
                ],
                "5": [
                  255,
                  239,
                  237,
                  0.05
                ],
                "10": [
                  255,
                  239,
                  237,
                  0.1
                ],
                "15": [
                  255,
                  239,
                  237,
                  0.15
                ],
                "20": [
                  255,
                  239,
                  237,
                  0.2
                ],
                "25": [
                  255,
                  239,
                  237,
                  0.25
                ],
                "30": [
                  255,
                  239,
                  237,
                  0.3
                ],
                "35": [
                  255,
                  239,
                  237,
                  0.35
                ],
                "40": [
                  255,
                  239,
                  237,
                  0.4
                ],
                "45": [
                  255,
                  239,
                  237,
                  0.45
                ],
                "50": [
                  255,
                  239,
                  237,
                  0.5
                ],
                "55": [
                  255,
                  239,
                  237,
                  0.55
                ],
                "60": [
                  255,
                  239,
                  237,
                  0.6
                ],
                "65": [
                  255,
                  239,
                  237,
                  0.65
                ],
                "70": [
                  255,
                  239,
                  237,
                  0.7
                ],
                "75": [
                  255,
                  239,
                  237,
                  0.75
                ],
                "80": [
                  255,
                  239,
                  237,
                  0.8
                ],
                "85": [
                  255,
                  239,
                  237,
                  0.85
                ],
                "90": [
                  255,
                  239,
                  237,
                  0.9
                ],
                "95": [
                  255,
                  239,
                  237,
                  0.95
                ],
                "100": [
                  255,
                  239,
                  237,
                  1
                ]
              }
            }
          },
          "primary": {
            "2": [
              1,
              32,
              50,
              1
            ],
            "4": [
              2,
              42,
              63,
              1
            ],
            "5": [
              3,
              45,
              68,
              1
            ],
            "6": [
              3,
              49,
              73,
              1
            ],
            "8": [
              4,
              56,
              83,
              1
            ],
            "10": [
              5,
              62,
              92,
              1
            ],
            "15": [
              7,
              77,
              113,
              1
            ],
            "20": [
              10,
              91,
              132,
              1
            ],
            "25": [
              13,
              105,
              151,
              1
            ],
            "30": [
              16,
              117,
              168,
              1
            ],
            "35": [
              20,
              129,
              184,
              1
            ],
            "40": [
              25,
              140,
              200,
              1
            ],
            "45": [
              32,
              151,
              214,
              1
            ],
            "50": [
              41,
              162,
              227,
              1
            ],
            "55": [
              53,
              172,
              239,
              1
            ],
            "60": [
              74,
              182,
              246,
              1
            ],
            "65": [
              97,
              191,
              250,
              1
            ],
            "70": [
              120,
              200,
              252,
              1
            ],
            "75": [
              141,
              208,
              253,
              1
            ],
            "80": [
              161,
              216,
              253,
              1
            ],
            "85": [
              179,
              223,
              254,
              1
            ],
            "90": [
              197,
              231,
              254,
              1
            ],
            "95": [
              214,
              238,
              254,
              1
            ],
            "100": [
              230,
              245,
              255,
              1
            ],
            "101": [
              234,
              246,
              255,
              1
            ],
            "102": [
              237,
              247,
              255,
              1
            ],
            "103": [
              240,
              249,
              255,
              1
            ],
            "104": [
              243,
              250,
              255,
              1
            ],
            "105": [
              246,
              251,
              255,
              1
            ],
            "translucent": {
              "10": {
                "0": [
                  5,
                  62,
                  92,
                  0
                ],
                "5": [
                  5,
                  62,
                  92,
                  0.05
                ],
                "10": [
                  5,
                  62,
                  92,
                  0.1
                ],
                "15": [
                  5,
                  62,
                  92,
                  0.15
                ],
                "20": [
                  5,
                  62,
                  92,
                  0.2
                ],
                "25": [
                  5,
                  62,
                  92,
                  0.25
                ],
                "30": [
                  5,
                  62,
                  92,
                  0.3
                ],
                "35": [
                  5,
                  62,
                  92,
                  0.35
                ],
                "40": [
                  5,
                  62,
                  92,
                  0.4
                ],
                "45": [
                  5,
                  62,
                  92,
                  0.45
                ],
                "50": [
                  5,
                  62,
                  92,
                  0.5
                ],
                "55": [
                  5,
                  62,
                  92,
                  0.55
                ],
                "60": [
                  5,
                  62,
                  92,
                  0.6
                ],
                "65": [
                  5,
                  62,
                  92,
                  0.65
                ],
                "70": [
                  5,
                  62,
                  92,
                  0.7
                ],
                "75": [
                  5,
                  62,
                  92,
                  0.75
                ],
                "80": [
                  5,
                  62,
                  92,
                  0.8
                ],
                "85": [
                  5,
                  62,
                  92,
                  0.85
                ],
                "90": [
                  5,
                  62,
                  92,
                  0.9
                ],
                "95": [
                  5,
                  62,
                  92,
                  0.95
                ],
                "100": [
                  5,
                  62,
                  92,
                  1
                ]
              },
              "50": {
                "0": [
                  41,
                  162,
                  227,
                  0
                ],
                "5": [
                  41,
                  162,
                  227,
                  0.05
                ],
                "10": [
                  41,
                  162,
                  227,
                  0.1
                ],
                "15": [
                  41,
                  162,
                  227,
                  0.15
                ],
                "20": [
                  41,
                  162,
                  227,
                  0.2
                ],
                "25": [
                  41,
                  162,
                  227,
                  0.25
                ],
                "30": [
                  41,
                  162,
                  227,
                  0.3
                ],
                "35": [
                  41,
                  162,
                  227,
                  0.35
                ],
                "40": [
                  41,
                  162,
                  227,
                  0.4
                ],
                "45": [
                  41,
                  162,
                  227,
                  0.45
                ],
                "50": [
                  41,
                  162,
                  227,
                  0.5
                ],
                "55": [
                  41,
                  162,
                  227,
                  0.55
                ],
                "60": [
                  41,
                  162,
                  227,
                  0.6
                ],
                "65": [
                  41,
                  162,
                  227,
                  0.65
                ],
                "70": [
                  41,
                  162,
                  227,
                  0.7
                ],
                "75": [
                  41,
                  162,
                  227,
                  0.75
                ],
                "80": [
                  41,
                  162,
                  227,
                  0.8
                ],
                "85": [
                  41,
                  162,
                  227,
                  0.85
                ],
                "90": [
                  41,
                  162,
                  227,
                  0.9
                ],
                "95": [
                  41,
                  162,
                  227,
                  0.95
                ],
                "100": [
                  41,
                  162,
                  227,
                  1
                ]
              },
              "100": {
                "0": [
                  230,
                  245,
                  255,
                  0
                ],
                "5": [
                  230,
                  245,
                  255,
                  0.05
                ],
                "10": [
                  230,
                  245,
                  255,
                  0.1
                ],
                "15": [
                  230,
                  245,
                  255,
                  0.15
                ],
                "20": [
                  230,
                  245,
                  255,
                  0.2
                ],
                "25": [
                  230,
                  245,
                  255,
                  0.25
                ],
                "30": [
                  230,
                  245,
                  255,
                  0.3
                ],
                "35": [
                  230,
                  245,
                  255,
                  0.35
                ],
                "40": [
                  230,
                  245,
                  255,
                  0.4
                ],
                "45": [
                  230,
                  245,
                  255,
                  0.45
                ],
                "50": [
                  230,
                  245,
                  255,
                  0.5
                ],
                "55": [
                  230,
                  245,
                  255,
                  0.55
                ],
                "60": [
                  230,
                  245,
                  255,
                  0.6
                ],
                "65": [
                  230,
                  245,
                  255,
                  0.65
                ],
                "70": [
                  230,
                  245,
                  255,
                  0.7
                ],
                "75": [
                  230,
                  245,
                  255,
                  0.75
                ],
                "80": [
                  230,
                  245,
                  255,
                  0.8
                ],
                "85": [
                  230,
                  245,
                  255,
                  0.85
                ],
                "90": [
                  230,
                  245,
                  255,
                  0.9
                ],
                "95": [
                  230,
                  245,
                  255,
                  0.95
                ],
                "100": [
                  230,
                  245,
                  255,
                  1
                ]
              }
            }
          },
          "secondary": {
            "2": [
              36,
              30,
              0,
              1
            ],
            "4": [
              46,
              38,
              0,
              1
            ],
            "5": [
              50,
              42,
              0,
              1
            ],
            "6": [
              54,
              45,
              0,
              1
            ],
            "8": [
              61,
              52,
              0,
              1
            ],
            "10": [
              68,
              58,
              0,
              1
            ],
            "15": [
              85,
              72,
              0,
              1
            ],
            "20": [
              100,
              86,
              0,
              1
            ],
            "25": [
              114,
              98,
              0,
              1
            ],
            "30": [
              128,
              110,
              0,
              1
            ],
            "35": [
              141,
              121,
              0,
              1
            ],
            "40": [
              153,
              132,
              0,
              1
            ],
            "45": [
              165,
              142,
              0,
              1
            ],
            "50": [
              176,
              152,
              0,
              1
            ],
            "55": [
              188,
              162,
              0,
              1
            ],
            "60": [
              199,
              172,
              0,
              1
            ],
            "65": [
              209,
              181,
              0,
              1
            ],
            "70": [
              220,
              190,
              0,
              1
            ],
            "75": [
              230,
              199,
              0,
              1
            ],
            "80": [
              240,
              208,
              0,
              1
            ],
            "85": [
              250,
              216,
              0,
              1
            ],
            "90": [
              255,
              226,
              75,
              1
            ],
            "95": [
              255,
              235,
              138,
              1
            ],
            "100": [
              255,
              243,
              186,
              1
            ],
            "101": [
              255,
              245,
              195,
              1
            ],
            "102": [
              255,
              246,
              204,
              1
            ],
            "103": [
              255,
              248,
              213,
              1
            ],
            "104": [
              255,
              249,
              221,
              1
            ],
            "105": [
              255,
              251,
              230,
              1
            ],
            "translucent": {
              "10": {
                "0": [
                  68,
                  58,
                  0,
                  0
                ],
                "5": [
                  68,
                  58,
                  0,
                  0.05
                ],
                "10": [
                  68,
                  58,
                  0,
                  0.1
                ],
                "15": [
                  68,
                  58,
                  0,
                  0.15
                ],
                "20": [
                  68,
                  58,
                  0,
                  0.2
                ],
                "25": [
                  68,
                  58,
                  0,
                  0.25
                ],
                "30": [
                  68,
                  58,
                  0,
                  0.3
                ],
                "35": [
                  68,
                  58,
                  0,
                  0.35
                ],
                "40": [
                  68,
                  58,
                  0,
                  0.4
                ],
                "45": [
                  68,
                  58,
                  0,
                  0.45
                ],
                "50": [
                  68,
                  58,
                  0,
                  0.5
                ],
                "55": [
                  68,
                  58,
                  0,
                  0.55
                ],
                "60": [
                  68,
                  58,
                  0,
                  0.6
                ],
                "65": [
                  68,
                  58,
                  0,
                  0.65
                ],
                "70": [
                  68,
                  58,
                  0,
                  0.7
                ],
                "75": [
                  68,
                  58,
                  0,
                  0.75
                ],
                "80": [
                  68,
                  58,
                  0,
                  0.8
                ],
                "85": [
                  68,
                  58,
                  0,
                  0.85
                ],
                "90": [
                  68,
                  58,
                  0,
                  0.9
                ],
                "95": [
                  68,
                  58,
                  0,
                  0.95
                ],
                "100": [
                  68,
                  58,
                  0,
                  1
                ]
              },
              "50": {
                "0": [
                  176,
                  152,
                  0,
                  0
                ],
                "5": [
                  176,
                  152,
                  0,
                  0.05
                ],
                "10": [
                  176,
                  152,
                  0,
                  0.1
                ],
                "15": [
                  176,
                  152,
                  0,
                  0.15
                ],
                "20": [
                  176,
                  152,
                  0,
                  0.2
                ],
                "25": [
                  176,
                  152,
                  0,
                  0.25
                ],
                "30": [
                  176,
                  152,
                  0,
                  0.3
                ],
                "35": [
                  176,
                  152,
                  0,
                  0.35
                ],
                "40": [
                  176,
                  152,
                  0,
                  0.4
                ],
                "45": [
                  176,
                  152,
                  0,
                  0.45
                ],
                "50": [
                  176,
                  152,
                  0,
                  0.5
                ],
                "55": [
                  176,
                  152,
                  0,
                  0.55
                ],
                "60": [
                  176,
                  152,
                  0,
                  0.6
                ],
                "65": [
                  176,
                  152,
                  0,
                  0.65
                ],
                "70": [
                  176,
                  152,
                  0,
                  0.7
                ],
                "75": [
                  176,
                  152,
                  0,
                  0.75
                ],
                "80": [
                  176,
                  152,
                  0,
                  0.8
                ],
                "85": [
                  176,
                  152,
                  0,
                  0.85
                ],
                "90": [
                  176,
                  152,
                  0,
                  0.9
                ],
                "95": [
                  176,
                  152,
                  0,
                  0.95
                ],
                "100": [
                  176,
                  152,
                  0,
                  1
                ]
              },
              "100": {
                "0": [
                  255,
                  243,
                  186,
                  0
                ],
                "5": [
                  255,
                  243,
                  186,
                  0.05
                ],
                "10": [
                  255,
                  243,
                  186,
                  0.1
                ],
                "15": [
                  255,
                  243,
                  186,
                  0.15
                ],
                "20": [
                  255,
                  243,
                  186,
                  0.2
                ],
                "25": [
                  255,
                  243,
                  186,
                  0.25
                ],
                "30": [
                  255,
                  243,
                  186,
                  0.3
                ],
                "35": [
                  255,
                  243,
                  186,
                  0.35
                ],
                "40": [
                  255,
                  243,
                  186,
                  0.4
                ],
                "45": [
                  255,
                  243,
                  186,
                  0.45
                ],
                "50": [
                  255,
                  243,
                  186,
                  0.5
                ],
                "55": [
                  255,
                  243,
                  186,
                  0.55
                ],
                "60": [
                  255,
                  243,
                  186,
                  0.6
                ],
                "65": [
                  255,
                  243,
                  186,
                  0.65
                ],
                "70": [
                  255,
                  243,
                  186,
                  0.7
                ],
                "75": [
                  255,
                  243,
                  186,
                  0.75
                ],
                "80": [
                  255,
                  243,
                  186,
                  0.8
                ],
                "85": [
                  255,
                  243,
                  186,
                  0.85
                ],
                "90": [
                  255,
                  243,
                  186,
                  0.9
                ],
                "95": [
                  255,
                  243,
                  186,
                  0.95
                ],
                "100": [
                  255,
                  243,
                  186,
                  1
                ]
              }
            }
          }
        },
        "bg": {
          "button": {
            "regular": {
              "base": [
                67,
                74,
                79,
                1
              ],
              "hover": [
                91,
                100,
                106,
                1
              ],
              "active": [
                79,
                87,
                93,
                1
              ],
              "disabled": [
                53,
                59,
                63,
                1
              ],
              "on": [
                25,
                140,
                200,
                1
              ],
              "on-hover": [
                32,
                151,
                214,
                1
              ],
              "on-active": [
                20,
                129,
                184,
                1
              ],
              "off": [
                67,
                74,
                79,
                1
              ],
              "off-hover": [
                91,
                100,
                106,
                1
              ],
              "off-active": [
                79,
                87,
                93,
                1
              ]
            },
            "outline": {
              "base": [
                144,
                155,
                162,
                0
              ],
              "hover": [
                144,
                155,
                162,
                0.1
              ],
              "active": [
                144,
                155,
                162,
                0.2
              ],
              "disabled": [
                144,
                155,
                162,
                0
              ],
              "on": [
                41,
                162,
                227,
                0.2
              ],
              "on-hover": [
                41,
                162,
                227,
                0.3
              ],
              "on-active": [
                41,
                162,
                227,
                0.4
              ],
              "off": [
                144,
                155,
                162,
                0
              ],
              "off-hover": [
                144,
                155,
                162,
                0.1
              ],
              "off-active": [
                144,
                155,
                162,
                0.2
              ]
            },
            "minimal": {
              "base": [
                144,
                155,
                162,
                0
              ],
              "hover": [
                144,
                155,
                162,
                0.1
              ],
              "active": [
                144,
                155,
                162,
                0.2
              ],
              "disabled": [
                144,
                155,
                162,
                0
              ],
              "on": [
                144,
                155,
                162,
                0.25
              ],
              "on-hover": [
                144,
                155,
                162,
                0.3
              ],
              "on-active": [
                144,
                155,
                162,
                0.4
              ],
              "off": [
                144,
                155,
                162,
                0
              ],
              "off-hover": [
                144,
                155,
                162,
                0.1
              ],
              "off-active": [
                144,
                155,
                162,
                0.2
              ]
            }
          },
          "default": [
            38,
            43,
            46,
            1
          ],
          "overlay": [
            47,
            53,
            57,
            1
          ],
          "inset": [
            31,
            35,
            38,
            1
          ],
          "subtle": [
            38,
            43,
            46,
            1
          ],
          "strong": [
            203,
            210,
            215,
            1
          ],
          "muted": [
            45,
            50,
            53,
            0.6
          ],
          "alternating": {
            "odd": [
              0,
              0,
              0,
              0.1
            ],
            "even": [
              53,
              59,
              63,
              0.5
            ]
          },
          "accent": {
            "primary": {
              "subtle": [
                5,
                62,
                92,
                1
              ],
              "strong": [
                161,
                216,
                253,
                1
              ],
              "strong-v": [
                74,
                182,
                246,
                1
              ],
              "muted": [
                5,
                62,
                92,
                0.5
              ]
            },
            "secondary": {
              "subtle": [
                68,
                58,
                0,
                1
              ],
              "strong": [
                240,
                208,
                0,
                1
              ],
              "strong-v": [
                199,
                172,
                0,
                1
              ],
              "muted": [
                68,
                58,
                0,
                0.4
              ]
            },
            "warning": {
              "subtle": [
                89,
                48,
                2,
                1
              ],
              "strong": [
                254,
                198,
                150,
                1
              ],
              "strong-v": [
                249,
                148,
                39,
                1
              ],
              "muted": [
                89,
                48,
                2,
                0.4
              ]
            },
            "danger": {
              "subtle": [
                119,
                12,
                17,
                1
              ],
              "strong": [
                254,
                195,
                188,
                1
              ],
              "strong-v": [
                253,
                141,
                130,
                1
              ],
              "muted": [
                119,
                12,
                17,
                0.4
              ]
            }
          }
        },
        "fg": {
          "button": {
            "regular": {
              "base": [
                241,
                243,
                244,
                1
              ],
              "hover": [
                250,
                251,
                251,
                1
              ],
              "active": [
                250,
                251,
                251,
                1
              ],
              "disabled": [
                184,
                192,
                199,
                0.5
              ],
              "on": [
                241,
                243,
                244,
                1
              ],
              "on-hover": [
                250,
                251,
                251,
                1
              ],
              "on-active": [
                250,
                251,
                251,
                1
              ],
              "off": [
                184,
                192,
                199,
                1
              ],
              "off-hover": [
                241,
                243,
                244,
                1
              ],
              "off-active": [
                250,
                251,
                251,
                1
              ]
            },
            "outline": {
              "base": [
                241,
                243,
                244,
                1
              ],
              "hover": [
                250,
                251,
                251,
                1
              ],
              "active": [
                250,
                251,
                251,
                1
              ],
              "disabled": [
                184,
                192,
                199,
                0.5
              ],
              "on": [
                197,
                231,
                254,
                1
              ],
              "on-hover": [
                179,
                223,
                254,
                1
              ],
              "on-active": [
                161,
                216,
                253,
                1
              ],
              "off": [
                184,
                192,
                199,
                1
              ],
              "off-hover": [
                241,
                243,
                244,
                1
              ],
              "off-active": [
                250,
                251,
                251,
                1
              ]
            },
            "minimal": {
              "base": [
                241,
                243,
                244,
                1
              ],
              "hover": [
                250,
                251,
                251,
                1
              ],
              "active": [
                250,
                251,
                251,
                1
              ],
              "disabled": [
                184,
                192,
                199,
                0.5
              ],
              "on": [
                179,
                223,
                254,
                1
              ],
              "on-hover": [
                179,
                223,
                254,
                1
              ],
              "on-active": [
                179,
                223,
                254,
                1
              ],
              "off": [
                184,
                192,
                199,
                1
              ],
              "off-hover": [
                241,
                243,
                244,
                1
              ],
              "off-active": [
                250,
                251,
                251,
                1
              ]
            }
          },
          "default": [
            241,
            243,
            244,
            1
          ],
          "strong": [
            250,
            251,
            251,
            1
          ],
          "subtle": [
            184,
            192,
            199,
            1
          ],
          "disabled": [
            184,
            192,
            199,
            0.5
          ],
          "on-strong": [
            38,
            43,
            46,
            1
          ],
          "on-strong-v": [
            0,
            0,
            0,
            1
          ],
          "inversed": {
            "default": [
              38,
              43,
              46,
              1
            ],
            "strong": [
              0,
              0,
              0,
              1
            ],
            "subtle": [
              102,
              112,
              119,
              1
            ]
          },
          "translucent": {
            "default": [
              250,
              251,
              251,
              0.9
            ],
            "strong": [
              250,
              251,
              251,
              1
            ],
            "subtle": [
              241,
              243,
              244,
              0.6
            ],
            "disabled": [
              184,
              192,
              199,
              0.5
            ],
            "on-strong": [
              0,
              0,
              0,
              0.9
            ],
            "on-strong-v": [
              0,
              0,
              0,
              0.8
            ]
          },
          "accent": {
            "primary": [
              179,
              223,
              254,
              1
            ],
            "secondary": [
              220,
              190,
              0,
              1
            ],
            "warning": [
              253,
              174,
              103,
              1
            ],
            "danger": [
              254,
              206,
              201,
              1
            ],
            "primary-v": [
              120,
              200,
              252,
              1
            ],
            "secondary-v": [
              199,
              172,
              0,
              1
            ],
            "warning-v": [
              249,
              148,
              39,
              1
            ],
            "danger-v": [
              254,
              169,
              160,
              1
            ]
          }
        },
        "border": {
          "button": {
            "regular": {
              "base": [
                79,
                87,
                93,
                1
              ],
              "hover": [
                184,
                192,
                199,
                1
              ],
              "active": [
                113,
                123,
                130,
                1
              ],
              "disabled": [
                144,
                155,
                162,
                0.4
              ],
              "on": [
                20,
                129,
                184,
                1
              ],
              "on-hover": [
                120,
                200,
                252,
                1
              ],
              "on-active": [
                120,
                200,
                252,
                1
              ],
              "off": [
                79,
                87,
                93,
                1
              ],
              "off-hover": [
                184,
                192,
                199,
                1
              ],
              "off-active": [
                113,
                123,
                130,
                1
              ]
            },
            "outline": {
              "base": [
                113,
                123,
                130,
                1
              ],
              "hover": [
                184,
                192,
                199,
                1
              ],
              "active": [
                113,
                123,
                130,
                1
              ],
              "disabled": [
                144,
                155,
                162,
                0.4
              ],
              "on": [
                120,
                200,
                252,
                1
              ],
              "on-hover": [
                120,
                200,
                252,
                1
              ],
              "on-active": [
                120,
                200,
                252,
                1
              ],
              "off": [
                79,
                87,
                93,
                1
              ],
              "off-hover": [
                184,
                192,
                199,
                1
              ],
              "off-active": [
                113,
                123,
                130,
                1
              ]
            }
          },
          "default": [
            113,
            123,
            130,
            1
          ],
          "subtle": [
            79,
            87,
            93,
            1
          ],
          "strong": [
            184,
            192,
            199,
            1
          ],
          "muted": [
            144,
            155,
            162,
            0.4
          ],
          "accent": {
            "primary": {
              "default": [
                20,
                129,
                184,
                1
              ],
              "strong": [
                120,
                200,
                252,
                1
              ]
            },
            "secondary": {
              "default": [
                141,
                121,
                0,
                1
              ],
              "strong": [
                220,
                190,
                0,
                1
              ]
            },
            "warning": {
              "default": [
                210,
                121,
                14,
                1
              ],
              "strong": [
                253,
                174,
                103,
                1
              ]
            },
            "danger": {
              "default": [
                234,
                42,
                47,
                1
              ],
              "strong": [
                254,
                169,
                160,
                1
              ]
            }
          }
        }
      },
      "shadow": {
        "button": {
          "regular": {
            "base": {},
            "active": {},
            "disabled": {}
          }
        }
      }
    },

    __resolvePath: function(path, obj, defaultValue = null, separator=".") {
      const keys = Array.isArray(path) ? path : path.split(separator);
      return keys.reduce((prev, curr) => prev ? prev[curr] : defaultValue, obj);
    },

    getColor(path, cKey) {
      return this.__resolvePath(path, this.colors)[cKey];
    }
  }
});
